"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Twitter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Twitter = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "twitter", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "twitter", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M18.854 13.55 30.022 0h-2.646l-9.698 11.765L9.933 0H1l11.712 17.79L1 32h2.647l10.24-12.424L22.067 32H31L18.853 13.55h.001Zm-3.625 4.398-1.187-1.772L4.6 2.08h4.065l7.62 11.377 1.187 1.771 9.905 14.788h-4.065l-8.083-12.067Z", fill: "#fff" }) })) })));
};
exports.Twitter = Twitter;
